import { HttpClient } from '@angular/common/http';
import { StudentService } from './../../shared-components/student/student.service';
import { Injectable } from '@angular/core';
import { YearService } from '../../shared-components/year/year.service';
import { System } from '../../shared-components/System';
import { Observable } from 'rxjs';
import { Team } from './team.model';

@Injectable()
export class TeamsService {

    // Properties

    // Class Functions
    constructor (
        private studentService: StudentService,
        private yearService: YearService,
        private http: HttpClient
    ) {}

    // Methods
    getStudentTeams(): Observable<Team[]> {
        // POST: returns the teams for a student
        const queryString = '?studentId=' + this.studentService.selectedStudent.Id +
            '&yearId=' + this.yearService.student360Year.Id;
        return this.http.get<Team[]>(System.apiURL.Student + 'GetStudentTeams' + queryString);
    }
}
